/**
 * Belcopia Upgrade Selectors
 * Renders dropdown upgrade options above Add to Cart.
 * Intercepts form submit to add main product + upgrades together.
 * Works with Impulse v5.x theme (product-template snippet).
 */
(function () {
  'use strict';

  var container = document.getElementById('BelcopiaUpgrades');
  if (!container) return;

  // ── Reposition into product form area ────────────────────────────────
  // Impulse renders blocks inside [data-product-blocks].
  // The buy_buttons block contains the product form.
  // Insert upgrade container right before the buy_buttons block.
  var productForm = document.querySelector('.product-single__form');
  if (!productForm) {
    productForm = document.querySelector('form[action*="/cart/add"]');
  }

  if (productForm) {
    // Walk up to find the .product-block wrapper of the buy_buttons block
    var buyBlock = productForm.closest('.product-block');
    if (buyBlock && buyBlock.parentElement) {
      buyBlock.parentElement.insertBefore(container, buyBlock);
    }
  }

  // Show container now that it's positioned correctly
  container.style.display = '';

  // ── Subtotal calculation ─────────────────────────────────────────────
  var selects = container.querySelectorAll('[data-upgrade-select]');
  var subtotalEl = document.getElementById('BelcopiaUpgradeSubtotal');
  var totalEl = document.getElementById('BelcopiaUpgradeTotal');

  function updateSubtotal() {
    var total = 0;
    selects.forEach(function (sel) {
      var opt = sel.options[sel.selectedIndex];
      var priceCents = parseInt(opt.getAttribute('data-price') || '0', 10);
      if (!isNaN(priceCents)) total += priceCents;
    });
    if (total > 0) {
      subtotalEl.style.display = '';
      totalEl.textContent = '+$' + (total / 100).toFixed(2);
    } else {
      subtotalEl.style.display = 'none';
    }
  }

  // ── Category notes (show/hide on selection) ────────────────────────
  var crankNote = container.querySelector('[data-crank-note]');

  function updateNotes() {
    if (crankNote) {
      var sel = crankNote.closest('.belcopia-upgrades__select-wrap')
        .querySelector('[data-upgrade-select]');
      crankNote.style.display = sel && sel.value ? '' : 'none';
    }
  }

  function updatePreviews() {
    selects.forEach(function (sel) {
      var opt = sel.options[sel.selectedIndex];
      var row = sel.closest('.belcopia-upgrades__row');
      if (!row) return;
      var link = row.querySelector('[data-upgrade-preview-link]');
      var img = row.querySelector('[data-upgrade-preview]');
      if (!img) return;
      var src = opt.getAttribute('data-image');
      var url = opt.getAttribute('data-url');
      if (sel.value && src) {
        img.src = src;
        img.alt = opt.getAttribute('data-title') || '';
        img.classList.add('is-visible');
        img.style.display = 'block';
        if (link) {
          link.href = url || '#';
          link.style.display = 'block';
        }
      } else {
        img.classList.remove('is-visible');
        img.style.display = 'none';
        img.src = '';
        if (link) {
          link.style.display = 'none';
          link.href = '#';
        }
      }
    });
  }

  selects.forEach(function (sel) {
    sel.addEventListener('change', function () {
      updateSubtotal();
      updateNotes();
      updatePreviews();
    });
  });

  // ── Intercept Add to Cart ────────────────────────────────────────────
  if (!productForm) return;

  // Get the product title for the _upgrade_for property
  // We target H1 specifically and use .innerText to avoid grabbing hidden <script> content
  var productTitleEl = document.querySelector(
    'h1.product-single__title, h1.product__title, h1[data-product-title], .product-single__title h1'
  );
  if (!productTitleEl) {
    productTitleEl = document.querySelector('.product-single__title, h1.product__title, [data-product-title]');
  }
  var productTitle = productTitleEl ? (productTitleEl.innerText || productTitleEl.textContent).split('\n')[0].trim() : '';

  productForm.addEventListener(
    'submit',
    function (e) {
      // Collect selected upgrades
      var upgradeItems = [];
      selects.forEach(function (sel) {
        var val = sel.value;
        if (val) {
          upgradeItems.push({
            id: parseInt(val, 10),
            quantity: 1,
            properties: { _upgrade_for: productTitle }
          });
        }
      });

      // If no upgrades selected, let form submit normally
      if (upgradeItems.length === 0) return;

      // Prevent default and stop theme handler
      e.preventDefault();
      e.stopImmediatePropagation();

      // Get main product variant ID
      var mainVariantInput = productForm.querySelector(
        'select[name="id"], input[name="id"]'
      );
      var mainVariantId = mainVariantInput ? mainVariantInput.value : null;
      if (!mainVariantId) return;

      // Get quantity
      var qtyInput = productForm.querySelector(
        'input[name="quantity"], select[name="quantity"]'
      );
      var mainQty = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;

      // Build items array: main product + upgrades
      var items = [{ id: parseInt(mainVariantId, 10), quantity: mainQty }];
      items = items.concat(upgradeItems);

      // Disable submit button
      var submitBtn = productForm.querySelector('[data-add-to-cart]');
      var originalHTML = '';
      if (submitBtn) {
        originalHTML = submitBtn.innerHTML;
        submitBtn.disabled = true;
        submitBtn.innerHTML =
          '<span data-add-to-cart-text>Adding...</span>';
      }

      // POST multi-item add
      fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({ items: items })
      })
        .then(function (r) {
          if (!r.ok) throw new Error('Cart add HTTP ' + r.status);
          return r.json();
        })
        .then(function (data) {
          // Success feedback
          if (submitBtn) {
            submitBtn.innerHTML =
              '<span data-add-to-cart-text>Added!</span>';
            setTimeout(function () {
              submitBtn.innerHTML = originalHTML;
              submitBtn.disabled = false;
            }, 2000);
          }

          // Trigger Impulse cart drawer (ajaxProduct:added event)
          document.dispatchEvent(
            new CustomEvent('ajaxProduct:added', {
              detail: { product: data }
            })
          );

          // Reset dropdowns
          selects.forEach(function (sel) {
            sel.selectedIndex = 0;
          });
          updateSubtotal();
          updatePreviews();
        })
        .catch(function (err) {
          console.error('[Belcopia Upgrades] Add failed:', err);
          if (submitBtn) {
            submitBtn.innerHTML = originalHTML;
            submitBtn.disabled = false;
          }
        });
    },
    true // capture phase — run before theme handler
  );
})();
